export default "__VITE_ASSET__dea5c800__"